var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"74a77b3d103fb7f4526f2b7c407ed750e4c68282"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-react@farmec-sa"]={id:"74a77b3d103fb7f4526f2b7c407ed750e4c68282"};
      